import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Element from 'element-ui'
// 分页组件
import Pagination from '@/components/Pagination'
// 自定义表格工具组件
import RightToolbar from '@/components/RightToolbar'
// 富文本组件
import Editor from '@/components/Editor'
// 文件上传组件
import FileUpload from '@/components/FileUpload'
// 图片上传组件
import ImageUpload from '@/components/ImageUpload'
// 图片预览组件
import ImagePreview from '@/components/ImagePreview'
import './style/element-variables.scss'
import '@/style/common.css' // global css
// import "font-awesome/css/font-awesome.css"
import Cookies from 'js-cookie'
import BaiduMap from 'vue-baidu-map'
import { BmlMarkerClusterer } from 'vue-baidu-map'
import axios from 'axios'
//将axios挂载到原型上
Vue.prototype.$axios = axios
//配置全局的axios默认值（可选）

axios.defaults.baseURL = 'https://aip.baidubce.com'
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded'
Vue.component('blm-marker-cluster', BmlMarkerClusterer)

Vue.use(BaiduMap, {
  ak: 'Liz5cx8NFb67bi5f97L81wjBufDzl6ew',
})

Vue.use(Element, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
})
Vue.component('Pagination', Pagination)
Vue.component('RightToolbar', RightToolbar)
Vue.component('Editor', Editor)
Vue.component('FileUpload', FileUpload)
Vue.component('ImageUpload', ImageUpload)
Vue.component('ImagePreview', ImagePreview)
import VueQuillEditor from 'vue-quill-editor'
// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts
Vue.use(VueQuillEditor, {
  placeholder: '请输入内容',
})
Vue.config.productionTip = false
Vue.prototype.$host = '/baidu'

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
